"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _FlexRow = require("../layout/flex/FlexRow");
var _Heading = _interopRequireDefault(require("../text/Heading"));
var _FlexItem = require("../layout/flex/FlexItem");
var _Button = require("../controls/buttons/Button");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _tokens = _interopRequireDefault(require("../../shared/tokens/tokens"));
var _jsxRuntime = require("react/jsx-runtime");
var ELEMENTS = {
  SEARCH: 'search',
  DOWNLOAD: 'download',
  EYE_OPTIONS: 'eye_options',
  FILTER: 'filter',
  VIEW: 'view',
  GROUP_BY: 'group_by',
  TABS: 'tabs'
};
var elementIdsReversed = Object.values(ELEMENTS).reverse();
var TableBarContainer = _styledComponents.default.div.withConfig({
  displayName: "TableBar__TableBarContainer",
  componentId: "sc-e36ms1-0"
})(["", ""], function (_ref) {
  var borderBottom = _ref.borderBottom;
  return borderBottom && (0, _styledComponents.css)(["border-bottom:1px solid ", ";"], _tokens.default.sky.sys.color.border.decorative);
});
var TableBarToolbar = (0, _styledComponents.default)(_FlexRow.FlexRow).withConfig({
  displayName: "TableBar__TableBarToolbar",
  componentId: "sc-e36ms1-1"
})(["padding-bottom:", ";"], _tokens.default.sky.sys.spacing['200']);
var sortButtons = function sortButtons(a, b) {
  var _b$props, _a$props;
  // buttons are sorted in the same order as the BUTTONS enum, with other buttons at the end
  return elementIdsReversed.indexOf((_b$props = b.props) === null || _b$props === void 0 ? void 0 : _b$props.id) - elementIdsReversed.indexOf((_a$props = a.props) === null || _a$props === void 0 ? void 0 : _a$props.id);
};
var TableBar = function TableBar(_ref2) {
  var title = _ref2.title,
    _ref2$borderBottom = _ref2.borderBottom,
    borderBottom = _ref2$borderBottom === void 0 ? true : _ref2$borderBottom,
    dataCy = _ref2['data-cy'],
    children = _ref2.children;
  var modifiedChildren = [];
  var tabs = undefined;
  /* force standard icons and emphasis on specific buttons */
  _react.default.Children.forEach(children, function (child, index) {
    var key = dataCy + '-' + (child.props.id || index);
    var commonProps = {
      key: key,
      cy: key,
      id: undefined
    };
    switch (child.props.id) {
      case ELEMENTS.SEARCH:
        modifiedChildren.push(/*#__PURE__*/_react.default.cloneElement(child, _objectSpread({
          emphasis: _Button.EMPHASIS.LOW,
          icon: 'search',
          text: null
        }, commonProps)));
        break;
      case ELEMENTS.DOWNLOAD:
        modifiedChildren.push(/*#__PURE__*/_react.default.cloneElement(child, _objectSpread({
          emphasis: _Button.EMPHASIS.LOW,
          icon: 'download',
          text: null
        }, commonProps)));
        break;
      case ELEMENTS.EYE_OPTIONS:
        modifiedChildren.push(/*#__PURE__*/_react.default.cloneElement(child, _objectSpread({
          emphasis: _Button.EMPHASIS.LOW,
          icon: 'view',
          text: null
        }, commonProps)));
        break;
      case ELEMENTS.FILTER:
      case ELEMENTS.VIEW:
      case ELEMENTS.GROUP_BY:
        modifiedChildren.push(/*#__PURE__*/_react.default.cloneElement(child, _objectSpread({
          emphasis: _Button.EMPHASIS.LOW
        }, commonProps)));
        break;
      case ELEMENTS.TABS:
        tabs = child;
        break;
      default:
        modifiedChildren.push(/*#__PURE__*/_react.default.cloneElement(child, _objectSpread({}, commonProps)));
    }
  });
  var sortedChildren = modifiedChildren.sort(sortButtons);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(TableBarContainer, {
    borderBottom: borderBottom,
    cy: dataCy,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(TableBarToolbar, {
      justifyContent: 'space-between',
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Heading.default, {
        size: '4',
        children: title
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FlexItem.FlexItem, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FlexRow.FlexRow, {
          children: sortedChildren
        })
      })]
    }), tabs]
  });
};
TableBar.ELEMENTS = ELEMENTS;
var _default = exports.default = TableBar;